<nav role="navigation">
  <ul class="menu menu--global" role="menu">
    <li role="menuitem"><a class="link--on-dark" routerLink="/">Home</a></li>
    <!--<li role="menuitem" [opusAuthorize]="'CreditCheck.Run'"><a class="link--on-dark" routerLink="/credit-check">Credit Check</a></li>-->
    <li role="menuitem"><a class="link--on-dark" [routerLink]="['credit-report-summary']">Summary</a></li>
    <li role="menuitem"><a class="link--on-dark" [routerLink]="['credit-report-reasons']">Reasons</a></li>
    <!-- <li role="menuitem" [opusAuthorize]="'Distribution.ViewShippingCharges'"><a class="link--on-dark" [routerLink]="['distribution']">Distribution</a></li> -->
    <!-- <li role="menuitem"><a class="link--on-dark" routerLink="/user-management">User Management</a></li> -->
  </ul>
</nav>
